const DEFAULTS =   {
  // Selector used to find the observable children
  observeSelector: '[data-in-view-style]',
  // Root element. Default sto the browser viewport
  // https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API#Intersection_observer_concepts_and_usage
  rootEl: null,
  onLoad: () => {},
};

export default class InViewStyle {

  constructor(scrollContainer, options = DEFAULTS) {
    // Merge options
    this.options = {...DEFAULTS, ...options};

    // Collect the children
    this.children = scrollContainer.querySelectorAll(this.options.observeSelector);

    // Create the observer
    this.observer = this.createIntersectionObsvr();

    // Observe the children
    this.children.forEach(child => this.observer.observe(child));
  }

  /**
   * Create an IntersectionObserver which takes the value of [data-in-view-style]
   * and applies it to [style]
   * Used for adding background-image only when the element is visible.
   * Unobserves the child when the threshold is reached.
   * @return {IntersectionObserver}
   */
  createIntersectionObsvr() {
    return new IntersectionObserver(changes => {
      changes.forEach(({ intersectionRatio, target }) => {
        if (intersectionRatio > 0) {
          // Hack to appease IE11.
          // TODO: Find a better solution for style,
          // because this isn't very reliable
          // (IE11 may ignore setAttribute if attribute exists already)
          target.setAttribute('style', target.dataset.inViewStyle);
          this.options.onLoad();
          // target.style.cssText = target.dataset.inViewStyle;
          this.observer.unobserve(target);
        }
      });
    }, {
      root: this.options.rootEl,
      threshold: [0, 1],
    });
  }

}
